import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlogCardGrid from "../../templates/blog-card-grid"
import ExternalLinks from "../../../external-links"

export default function BlogFeatures(props) {
  const query = useStaticQuery(graphql`
    query {
      blogSecurityCommitment: file(
        relativePath: {
          eq: "4_COMPANY/Security/blog/blog image 2.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogSecurityFeatures: file(
        relativePath: {
          eq: "4_COMPANY/Security/blog/blog image 1.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 750) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const blogCardDetails = [
    {
      fluidImage: query.blogSecurityCommitment.childImageSharp.fluid,
      title: "Solidifying our Commitment to the Highest Standard of Data Security",
      description:
        "Our top priority at Mappedin is keeping our customers' maps and associated data safe and secure.",
      link: ExternalLinks.hubspot.securityCommitment,
    },
    {
      fluidImage: query.blogSecurityFeatures.childImageSharp.fluid,
      title: "New Mappedin Features that Enhance Security Practices",
      description:
        "As Mappedin’s product platform grows, so do our considerations around security and privacy.",
      link: ExternalLinks.hubspot.securityFeatures,
    },
  ]

  return (
    <>
      <BlogCardGrid
        title="Learn more about our approach to data and security"
        blogCardDetails={blogCardDetails}
      />
    </>
  )
}
